import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	endStandupButtonNonfinal: {
		id: 'standups.control-buttons.end-standup-button-nonfinal',
		defaultMessage: 'End stand-up',
		description: 'Text on button for users to leave a stand-up happening at the moment',
	},
});
